var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M307.13,8.43c-11.21-11.21-29.4-11.21-40.61,0-11.21,11.21-11.21,29.4,0,40.61l8.43,8.43L25.19,307.14C9.05,323.27,0,345.15,0,368.01v4.93c0,47.51,38.55,86.06,86.06,86.06h4.93c22.86,0,44.73-9.05,60.87-25.19l249.76-249.76,8.43,8.43c11.21,11.21,29.4,11.21,40.61,0,11.21-11.21,11.21-29.4,0-40.61l-28.69-28.69-86.06-86.06-28.69-28.69h-.09ZM184.05,229.5l131.51-131.51,45.45,45.45-86.06,86.06h-90.99.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVial);
export default __webpack_public_path__ + "static/media/vial.561316a8f79dbd8640d31bf3857b4cd6.svg";
export { ForwardRef as ReactComponent };